export default __webpack_public_path__ + "img/Terrain-Maps-New-Mexico-56a7bff5157bf3c79ecd059aabd717a0.jpg";